export const about = [{ id: 2, label: "Description", value: "" }];
